/*
  datalayer-link-click.js

  Pushes a `linkClick` event to window.dataLayer on every anchor click.
  Replicates GTM's built-in Click trigger variables so custom GTM tags / GA4
  can consume the data consistently.

  Variables pushed:
    event                – "linkClick"
    gtm.element          – the clicked <a> element (DOM reference)
    gtm.elementClasses   – element.className  (Click Classes)
    gtm.elementId        – element.id         (Click ID)
    gtm.elementText      – trimmed text content (Click Text)
    gtm.elementUrl       – resolved absolute href (Click URL)
    Page Hostname        – window.location.hostname
    Page Path            – window.location.pathname  (no domain)
    Page URL             – window.location.href      (full URL)
*/

export function initDataLayerLinkClick() {
  if (window.__jurnalDlLinkClickBound) return;
  window.__jurnalDlLinkClickBound = true;

  window.dataLayer = window.dataLayer || [];

  window.addEventListener('click', function (e) {
    try {
      // Walk up to the nearest <a>.
      let el = e.target;
      while (el && el !== document && el.tagName !== 'A') {
        el = el.parentElement;
      }
      if (!el || el.tagName !== 'A') return;

      // Skip .cta-waba — waba-trigger.js pushes its own dataLayer event
      // after {{code}} is resolved to the final [Req.Jxxx] format.
      if (el.classList && el.classList.contains('cta-waba')) return;

      const rawHref = el.getAttribute('href') || '';

      // Resolve relative/root-relative hrefs to absolute URL.
      let resolvedUrl = rawHref;
      try {
        if (rawHref && rawHref !== '#' && !rawHref.startsWith('#')) {
          resolvedUrl = new URL(rawHref, window.location.href).href;
        }
      } catch (_) {}

      const dlPayload = {
        event:                 'linkClick',
        'gtm.triggers':        '',
        'gtm.element':         el,
        'gtm.elementClasses':  el.className || '',
        'gtm.elementId':       el.id || '',
        'gtm.elementText':     (el.textContent || '').replace(/\s+/g, ' ').trim().substring(0, 200),
        'gtm.elementUrl':      resolvedUrl,
        'Page Hostname':       window.location.hostname,
        'Page Path':           window.location.pathname,
        'Page URL':            window.location.href,
      };

      if (window.__jurnalWabaDebug) {
        console.log('[mlat datalayer] linkClick →', {
          '_event':        dlPayload.event,
          'Click Classes': dlPayload['gtm.elementClasses'],
          'Click ID':      dlPayload['gtm.elementId'],
          'Click Text':    dlPayload['gtm.elementText'],
          'Click URL':     dlPayload['gtm.elementUrl'],
          'Page Hostname': dlPayload['Page Hostname'],
          'Page Path':     dlPayload['Page Path'],
          'Page URL':      dlPayload['Page URL'],
        });
      }

      window.dataLayer.push(dlPayload);
    } catch (_) {}
  }, { capture: true, passive: true });
}
